import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import OutsideClickHandler from 'react-outside-click-handler';

import { Container } from "../../components/Container/Container";
import GetCards from "../../components/GetCards/GetCards";
import ToggleView from "../../components/ToggleView/ToggleView";
import Svg from "../../assets/icons/icons";
import Search from "../../components/Search/Search";
import { DispatchMessage } from "../../components/DispatchMessage/dispatchMessage";

import { addToFavorites, requestFromManager, requestFromManagerbyContent } from "../../store/favorites/actions";

import { colors as c } from "../../styles/variables";
import { Small } from "../../styles/typography/typography";

import { LinkSt } from "../../components/Carousel/style";
import { ContainerCollectionSt, HeaderSt, SettingsMenuSt, SettingsToggleSt } from "./style";
import {
    H3St,
    ItemSettingsSt,
    SettingsLeftSt,
    SettingsMenuWrapperSt,
    SettingsRigthSt,
    SpanSt,
    WrapItemSt,
    SecondLevelSt,
    SecondLevelItemSt,
    HeaderTopSt,
    TitleBlockSt
} from "../collections/style";

import i18n from "i18next";

const Collection = ({ collectionComponents, numberCollection }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [dashboard, setDashboard] = useState(true);
    const [chooseCard, setChooseCard] = useState(false);
    const [allchooseCard, setAllchooseCard] = useState([]);
    const [menuWithRequestIsOpen, setMenuWithRequestIsOpen] = useState(false);
    //попап после отправки на сервер
    const [dispatchMessageControl, setDispatchMessageControl] = useState(false);
    const [requestFromManagerShown, setRequestFromManagerShown] = useState(false);
    const [popupAddFavorites, setPopupAddFavorites] = useState(false);
    const [settingsMobTimeout, setSettingsMobTimeout] = useState(false);

    const dispatch = useDispatch();
    const messageallProjectsAdded = useSelector((store) => store.favorites.messageallProjectsAdded);
    const favoritesMessage = useSelector((store) => store.favorites.message);
    const favoritesProject = useSelector((store) => store.favorites.project);
    const token = useSelector((store) => store.auth.dataToken.token);
    const isLoggedIn = useSelector((store) => store.auth.isLoggedIn);
    const manager_email = useSelector((store) => store.auth.user.managers && (store.auth.user.managers[0] && store.auth.user.managers[0].email));

    const location = useLocation();

    const timers = useRef([]);
    useEffect(() => () => { timers.current.forEach(clearTimeout) }, []);

    // актуальные значения для чтения внутри эффектов
    const dispatchMessageControlRef = useRef(dispatchMessageControl);
    dispatchMessageControlRef.current = dispatchMessageControl;

    const _handleOpenMenuClick = () => {
        setMenuIsOpen((prev) => !prev);
    };

    const _handleOpenMenuWithRequestClick = () => {
        setRequestFromManagerShown(false);
        setMenuWithRequestIsOpen((prev) => !prev);
    };

    const _onToggleViewClick = (x) => {
        setDashboard(x);
        if (x !== dashboard) {
            setChooseCard(false);
        }
    };

    //запрос на контент
    const _handleContentRequestClick = () => {
        if (allchooseCard.length > 0) {
            dispatch(requestFromManagerbyContent(allchooseCard, token));
            setChooseCard(true);
            setAllchooseCard([]);
            setDispatchMessageControl(true);

            timers.current.push(setTimeout(() => {
                setMenuWithRequestIsOpen(false);
            }, 1500));

            timers.current.push(setTimeout(() => {
                setChooseCard(false);
            }, 1));
        }
    };

    //выбрать чекетом все карты на странице
    const _chooseCard = () => {
        setChooseCard((prev) => !prev);
    };

    // запрос у менеджера
    const _requestManager = () => {
        if (allchooseCard.length > 0) {
            dispatch(requestFromManager(allchooseCard, token));
            setChooseCard(true);
            setAllchooseCard([]);
            setDispatchMessageControl(true);

            timers.current.push(setTimeout(() => {
                setMenuWithRequestIsOpen(false);
            }, 1500));

            timers.current.push(setTimeout(() => {
                setChooseCard(false);
            }, 1));
        }
    };

    //добавить все выбранные карты в allchooseCard
    const _getallchooseCard = useCallback((allCards, status) => {
        if (status === "add" || status === "addAll") {
            setAllchooseCard((prev) => prev.includes(allCards) ? prev : [...prev, allCards]);
        }
        else if (status === "remove") {
            setAllchooseCard((prev) => prev.filter((item) => item !== allCards));
        }
        else if (status === "removeAll") {
            setAllchooseCard([]);
        }
    }, []);

    // Отправка прочеканных карт на сервер в избранное
    const _sendChooseCard = () => {
        if (allchooseCard.length > 0) {
            dispatch(addToFavorites(allchooseCard, "catalog", token));
        }
        setChooseCard(false);
        setAllchooseCard([]);
        setDispatchMessageControl(true);
    };

    // componentDidMount
    useEffect(() => {
        const timer = setTimeout(() => {
            setSettingsMobTimeout(true);
        }, 1000);
        return () => { clearTimeout(timer) };
    }, []);

    // componentDidUpdate: попап после отправки в избранное
    const isFirstFavorites = useRef(true);
    useEffect(() => {
        if (isFirstFavorites.current) {
            isFirstFavorites.current = false;
            return;
        }

        if (dispatchMessageControlRef.current) {
            setPopupAddFavorites(true);
            timers.current.push(setTimeout(() => {
                setPopupAddFavorites(false);
            }, 1500));
        }
        setDispatchMessageControl(false);
    }, [favoritesProject.length, messageallProjectsAdded]);

    // componentDidUpdate: попап после запроса у менеджера
    const isFirstMessage = useRef(true);
    useEffect(() => {
        if (isFirstMessage.current) {
            isFirstMessage.current = false;
            return;
        }

        setRequestFromManagerShown(true);
        timers.current.push(setTimeout(() => {
            setRequestFromManagerShown(false);
        }, 1500));
        setDispatchMessageControl(false);
    }, [favoritesMessage]);

    // componentDidUpdate: если ничего не выбрано — закрываем меню запроса
    useEffect(() => {
        if (allchooseCard.length === 0 && menuWithRequestIsOpen) {
            setMenuWithRequestIsOpen(false);
        }
    }, [allchooseCard.length, menuWithRequestIsOpen]);

    return (
        <ContainerCollectionSt collectionComponents={collectionComponents}>
            <Container padding="true">
                {!collectionComponents && <HeaderSt>
                    <HeaderTopSt>
                        <TitleBlockSt>
                            <H3St>{i18n.t(`collections.collections`)}</H3St>
                            <LinkSt to={"/collections"}><Small uppercase bold color={c.blue}>{i18n.t(`home.see_all`)}</Small></LinkSt>
                        </TitleBlockSt>
                        {(window.innerWidth < 768)
                            ? ""
                            : <>
                                <div style={{ display: 'none' }}>
                                    <Search
                                        iconSearch="search"
                                        placeholder={i18n.t(`favorites.add_by_name`)}
                                        searchBoxIsOpen={true}
                                    />
                                </div>
                                <ToggleView selected={dashboard ? "dashboard" : "list"} toggleViewChange={(x) => _onToggleViewClick(x)} />
                            </>
                        }
                    </HeaderTopSt>
                </HeaderSt>}
                <OutsideClickHandler onOutsideClick={() => { setMenuIsOpen(false) }}>
                    <SettingsMenuSt id={"test"}>
                        {(window.innerWidth < 768 && isLoggedIn && settingsMobTimeout)
                            ?
                            <SettingsToggleSt>
                                <div
                                    onClick={_handleOpenMenuClick}
                                    className="toggle" aria-label={i18n.t(`collections.open_the_menu`)} type="button">
                                    <span className="visually-hidden">{i18n.t(`collections.open_the_menu`)}</span>
                                    <Svg type={menuIsOpen ? "close" : "settings"} />
                                </div>

                            </SettingsToggleSt>
                            : ""
                        }
                        {isLoggedIn && (
                            <div style={{ display: 'block' }}>
                                <SettingsMenuWrapperSt className={menuIsOpen && window.innerWidth < 768 ? "opened" : ""}>
                                    <>
                                        <div>
                                            <SettingsLeftSt>
                                                <form style={{ display: 'block' }}>
                                                    <input type="checkbox" checked={chooseCard} onChange={() => _chooseCard()} /> {i18n.t(`collections.select_all`)}
                                                </form>
                                            </SettingsLeftSt>
                                            <SettingsRigthSt>
                                                {(window.innerWidth > 768) &&
                                                    <ItemSettingsSt>
                                                        {/* открыть/закрыть меню запрос менеджеру */}
                                                        <WrapItemSt className="WrapItemStyled" onClick={allchooseCard.length > 0 ? () => _handleOpenMenuWithRequestClick() : undefined}>
                                                            <SpanSt color={allchooseCard.length > 0 ? c.black : c.grey_passive}>{i18n.t(`collections.request_from_the_manager`)}</SpanSt>
                                                            <Svg className={menuWithRequestIsOpen ? "keyboard_arrow_top" : ""} type="keyboard_arrow"
                                                                color={allchooseCard.length > 0 ? c.black : c.grey_passive} />
                                                        </WrapItemSt>

                                                        {(menuWithRequestIsOpen)
                                                            && (
                                                                <SecondLevelSt>
                                                                    {manager_email &&
                                                                        <SecondLevelItemSt onClick={() => _requestManager()}>
                                                                            <Svg type="add" color={c.blue_active} />
                                                                            <LinkSt >
                                                                                <Small color={c.blue_active}>{i18n.t(`profile.add_promo_materials`)}</Small>
                                                                            </LinkSt>
                                                                        </SecondLevelItemSt>
                                                                    }
                                                                    {manager_email &&
                                                                        <SecondLevelItemSt onClick={() => _handleContentRequestClick()}>
                                                                            <Svg type="mail_outline" color={c.blue_active} />
                                                                            <LinkSt>
                                                                                <Small color={c.blue_active}>контент</Small>
                                                                            </LinkSt>
                                                                        </SecondLevelItemSt>
                                                                    }
                                                                    {/* popup с инфой */}
                                                                    {requestFromManagerShown &&
                                                                        <DispatchMessage message={favoritesMessage[1].added && (favoritesMessage[1].added.length > 0 ? i18n.t(`favorites.request_has_been_sent`) : i18n.t(`favorites.request_already_exists`))} />
                                                                    }
                                                                </SecondLevelSt>
                                                            )
                                                        }
                                                    </ItemSettingsSt>
                                                }
                                                {/* для моб версии */}
                                                {(window.innerWidth < 768) && (
                                                    <>
                                                        {/* запрос на контент */}
                                                        {manager_email && <ItemSettingsSt onClick={() => _handleContentRequestClick()}>
                                                            <Svg
                                                                type="mail_outline"
                                                                color={allchooseCard.length > 0 ? c.blue_active : c.grey_passive} />
                                                            <SpanSt color={allchooseCard.length > 0 ? c.blue_active : c.grey_passive}>{i18n.t(`collections.request_content`)}</SpanSt>
                                                        </ItemSettingsSt>}
                                                        {/* запрос на доп.материалы */}
                                                        {manager_email && <ItemSettingsSt onClick={() => _requestManager()}>
                                                            <Svg
                                                                type="add"
                                                                color={allchooseCard.length > 0 ? c.blue_active : c.grey_passive} />
                                                            <SpanSt color={allchooseCard.length > 0 ? c.blue_active : c.grey_passive}>{i18n.t(`profile.add_promo_materials`)}</SpanSt>

                                                        </ItemSettingsSt>}
                                                    </>
                                                )}

                                                {/* ДОБАВИТЬ В ИЗБРАННОЕ   */}
                                                <ItemSettingsSt onClick={() => _sendChooseCard()}>
                                                    <Svg type="bookmark_border"
                                                        color={allchooseCard.length > 0 ? c.black : c.grey_passive} />
                                                    <SpanSt color={allchooseCard.length > 0 ? c.black : c.grey_passive}>{i18n.t(`collections.add_to_favourites`)}</SpanSt>
                                                    {popupAddFavorites && <DispatchMessage message={messageallProjectsAdded ? i18n.t(`favorites.already_added_to_favorites`) : i18n.t(`favorites.added_to_favorites`)} />}
                                                </ItemSettingsSt>
                                                {requestFromManagerShown && (window.innerWidth < 768) && <DispatchMessage message={favoritesMessage[1].added && (favoritesMessage[1].added.length > 0 ? i18n.t(`favorites.request_has_been_sent`) : i18n.t(`favorites.request_already_exists`))} />}
                                            </SettingsRigthSt>
                                        </div>

                                    </>
                                </SettingsMenuWrapperSt>
                            </div>
                        )}
                    </SettingsMenuSt>
                </OutsideClickHandler>
                <GetCards
                    sourceCards={`collections/${numberCollection ? numberCollection : location.pathname.substr(location.pathname.lastIndexOf('/',) + 1)}`}
                    link={!collectionComponents ? false : "collections/" + numberCollection}
                    type="catalog"
                    cardDisplayType="grid"
                    tile={dashboard}
                    chooseCard={chooseCard}
                    page="collections"
                    _getallchooseCard={_getallchooseCard}
                />
            </Container>
        </ContainerCollectionSt>
    )
};

export default withTranslation()(Collection);
